import {gql, useQuery} from "@apollo/client";
import {DSP_FIELDS, DspType} from "../types/DspType";
import {useEffect, useState} from "react";

export const GET_NEXT_ACTION_LIST = gql`
  query DeliveryQuery {
    getNextActionList {
      name
      value
    }
  }
`;

export interface NextActionListResponse {
    getNextActionList: NextActionListType[];
}

export interface NextActionListType {
    name: string;
    value: number;
}